import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/use-i18n'

const Around: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen">
      <main className="max-w-3xl mx-auto px-3 sm:px-4 lg:px-8 py-8 sm:py-12">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-8 sm:p-12 text-center">
          <div className="text-5xl mb-4">📍</div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-3">{t('around.title')}</h1>
          <p className="text-white/60 text-sm sm:text-base leading-relaxed">{t('around.subtitle')}</p>
          <span className="inline-block mt-6 rounded-full bg-violet-500/20 px-4 py-2 text-sm font-semibold text-violet-300">
            {t('around.comingSoon')}
          </span>
        </div>
        <p className="mt-8 text-center text-sm text-white/40">
          <Link to="/dashboard" className="hover:text-white/70 underline">
            {t('nav.home')}
          </Link>
        </p>
      </main>
    </div>
  )
}

export default Around
